"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = underline;
function underline() {
  return "\n    text-decoration: underline;\n    cursor: pointer;\n  ";
}